<div class="modal-content">
<div class="modal-content modal-edit-self-report"  *ngIf="params['component'] === 'SrOverview'">
    <div class="modal-header">
        <h4 class="modal-title help-btn">
            {{ params['title'] | translate }}
        </h4>
    </div>
    <div class="modal-body">
        <button type="button" class="btn btn-link close" (click)="close()" aria-label="Close">
        </button>

        <ng-container *ngIf="groupNames.length > 0; else noGroupTemplate">
            <div class="row">
                <div class="float-xs-right paginate">
                    <i class="paginate--icon fas fa-chevron-left" [class.disabled]="currentPage === 0" (click)="prev()"></i>
                    <b> {{ currentPage + 1 }} </b>
                    <i class="paginate--icon fas fa-chevron-right" [class.disabled]="totalPage === (currentPage + 1)" (click)="next()"></i>
                </div>
            </div>
    
            <div class="row">
                <div class="col-xs-4" *ngFor="let groupName of groupNames">
                    <h3 class="lbl-card"> {{ groupName['name_' + itemLanguage] }} </h3>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-4 group-data" *ngFor="let groupFeeling of groupFeelings; let i = index">
                    <div class="row mt-1" *ngIf="groupFeeling && groupFeeling['feelings'].length > 0">
                        <ng-container>
                            <span class="col-xs-12 lbl-card">
                                <ng-container *ngIf="groupFeeling.parent_name"> 
                                    {{ groupFeeling.parent_name }} ->
                                </ng-container>
                                {{ groupFeeling.name }}
                            </span>
                            <div class="col-xs-11 selected-domains">
                                <ng-container *ngFor="let feeling of groupFeeling['feelings']">
                                    <div class="row selected-domains--item">
                                        <div class="col-xs-8">
                                            <span>
                                                {{feeling['name_' + itemLanguage]}} <br/>
                                            </span>
                                        </div>
                                        <div class="col-xs-2">
                                            <span *ngIf="feeling.is_acute">
                                                {{ feeling['trigger_point'] }}/5
                                            </span>
                                        </div>
                                        <div class="col-xs-1">
                                            <ng-container *ngIf="feeling.is_acute">
                                                <i class="fas fa-clock"></i>
                                            </ng-container>
                                            <ng-container *ngIf="!feeling.is_acute">
                                                <i class="fal fa-history"></i>
                                            </ng-container>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                        <span class="col-xs-12 mt-1">{{ 'Trigger' | translate}} : {{ groupFeeling.trigger_no }}</span>
                        <span class="col-xs-12 mt-1" *ngIf="!(i % itemPerRow) && !currentPage">{{ 'Age' | translate}} : {{groupFeeling.min_age}} - {{groupFeeling.max_age}}</span>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #noGroupTemplate>
            {{ 'This Self-report has no config.' | translate }}
        </ng-template>
    </div>
</div>